// src/pages/hotel-bookings/utils/hotelBookingFormat.ts
//
// Date and money formatting for the hotel booking pages.

/** "15 Sep 2026"; passes an unparseable value through rather than hiding it. */
export function formatDate(value?: string | null): string {
  const s = String(value ?? "").trim();
  if (!s) return "—";
  // Date-only values are calendar dates, not instants: never shift them by timezone.
  const d = /^\d{4}-\d{2}-\d{2}$/.test(s) ? new Date(`${s}T00:00:00`) : new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "2-digit" });
}

export function formatDateTime(value?: string | null): string {
  const s = String(value ?? "").trim();
  if (!s) return "—";
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatMoney(amount: number | null | undefined, currency?: string | null): string {
  if (amount === null || amount === undefined || !Number.isFinite(Number(amount))) return "—";
  const code = String(currency || "INR").trim().toUpperCase() || "INR";
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: code,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(amount));
  } catch {
    return `${code} ${Number(amount).toFixed(2)}`;
  }
}
